import { attendeeFetchData, attendeeDeleteData, attendeePutData } from "./index";

const agendaAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda`),
  fetchSessionByID: (attendeeId, sessionId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda/sessions/${sessionId}`),
  addToScheduler: (attendeeId, sessionId, params) => attendeePutData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/schedule`, {}, {params: params}),
  removeFromScheduler: (attendeeId, sessionId) => attendeeDeleteData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/schedule`),

  changeVerificationCode: (attendeeId, sessionId, data) =>  attendeePutData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/verification-code`,data),
  markAsAttended: (attendeeId, sessionId, data) =>  attendeePutData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/mark-as-attended`,data),
  markAsNotAttended: (attendeeId, sessionId, data) =>  attendeeDeleteData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/mark-as-attended`,data),

  fetchSessionMaterial: (attendeeId, sessionId, materialId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda/sessions/${sessionId}/materials/${materialId}`),
};

export default agendaAPI;
